
import { Vue, Options } from "vue-class-component"; // 基本需要
import { dateConversion, getLocalProject } from "@/utils"; //类型
import { store } from "@/store";
import { ElMessage } from "element-plus";
import "@/assets/iconfont/font_3410179_5uqi6h3hn2r/iconfont.css"; //引入仓库
import * as echarts from "echarts";
import axios from 'axios'
import { readUserProfile } from "@/store/main/getters";

@Options({
  watch: {
    radio_time(newValue) {
      if (newValue == 0) {
        return;
      }
      const today = new Date();
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零
        const day = String(date.getDate()).padStart(2, "0"); // 补零
        return `${year}-${month}-${day}`;
      };
      if (newValue === 4) {
        this.start_date = "";
        this.end_date = "";
      } else if (newValue === 5) {
        const sixMonthsAgo = new Date(
          today.getFullYear(),
          today.getMonth() - 6,
          today.getDate()
        );
        this.start_date = formatDate(sixMonthsAgo);
        this.end_date = formatDate(today);
      } else if (newValue === 6) {
        const oneYearAgo = new Date(
          today.getFullYear() - 1,
          today.getMonth(),
          today.getDate()
        );
        this.start_date = formatDate(oneYearAgo);
        this.end_date = formatDate(today);
      }
      this.all_skin_data_api();
    },
  },
})

export default class GamesNew extends Vue {
  inColumns = [
    {label: 'HUD_dc', prop: 'HUD_dc', width: 100},
    {label: 'Particle_dc', prop: 'Particle_dc', width: 100},
    {label: 'Scene_dc', prop: 'Scene_dc', width: 100},
    {label: '三角形数均值', prop: 'Tris', width: 120},
    {label: 'UI_dc', prop: 'UI_dc', width: 100},
    {label: '顶点数均值', prop: 'Verts', width: 120},
    {label: 'DrawCall均值', prop: 'avg_dc', width: 120},
    {label: 'Mono堆内存峰值(MB)', prop: 'avg_monomem', width: 180},
    {label: 'GC次数', prop: 'gc', width: 100},
    {label: 'Mono已用内存峰值(MB)', prop: 'monomem', width: 180},
  ]

  async dispatchGetHokSkinDataExport(store, params) {
    const {data} = await axios('report/all_skin_export/', {params})
    return data
  }

  addHokAll = []
  async dispatchGetHokSkinDataPage(store, params) {
    const {data} = await axios('report/all_skin_data_more/', {params})
    this.addHokAll = data
  }

  hokSkinData = []
  async dispatchGetHokSkinData(store, params) {
    const {data} = await axios('report/all_skin_data/', {params})
    this.hokSkinData = data
  }

  skinDevices = []
  async dispatchGetHokSkinDevices(store, params) {
    const {data} = await axios('report/skin_device_list_v1/', {params})
    this.skinDevices = data
  }

  skin_versions = []
  async dispatchGetHokSkinVersions(store, params) {
    const {data} = await axios('report/skin_versions/', {params})
    this.skin_versions = data.version_list
  }

  addHokOut = []
  async dispatchGetHokOutAdd(store, params) {
    const {data} = await axios('report/skin_data_aov_more/', {params})
    this.addHokOut = data
  }

  addHokIn = []
  async dispatchGetHokInAdd(store, params) {
    const {data} = await axios('report/in_skin_data_aov_more/', {params})
    this.addHokIn = data
  }

  device_out_list = []
  async dispatchGetHokDeviceOutList(store, params) {
    const {data} = await axios('report/skin_device_list/', {params})
    this.device_out_list = data.device_list
  }

  device_list = []
  async dispatchGetHokDeviceList(store, params) {
    const {data} = await axios('report/skin_device_list/', {params})
    this.device_list = data.device_list
  }

  hok_out_trend_data = {device_names: [], series: [], x_axis: []}
  async dispatchGetHokOutSkinTrend(store, params) {
    const {data} = await axios('report/skin_trend/', {params})
    this.hok_out_trend_data = data
  }

  hokIcon = {hero_list: [], skin_list: []}
  async dispatchGetHokIcon(store, params) {
    const {data} = await axios('proj/sgame_icon/', {params})
    this.hokIcon = data
  }

  async dispatchGetHokIn(store, params) {
    const {data} = await axios('report/in_skin_data_aov/', {params})
    this.hokinData = data
  }

  async dispatchGetHokOut(store, params) {
    const {data} = await axios('report/skin_data_aov/', {params})
    this.hokOutData = data
  }

  hok_in_trend_data = {device_names: [], series: [], x_axis: []}
  async dispatchGetHokInSkinTrend(store, params) {
    const {data} = await axios('report/in_skin_trend/', {params})
    this.hok_in_trend_data = data
  }

  public localProject = 14;
  public all_skin_data = [];
  extractSubsetFromObject(originalObject, keysArray) {
    return Object.keys(originalObject) // 获取所有键
      .filter((key) => keysArray.includes(key)) // 筛选出需要的键
      .reduce((newObj, key) => {
        // 构建新对象
        newObj[key] = originalObject[key];
        return newObj;
      }, {});
  }
  public filter_page_data = {};
  public all_skin_data_page = 0;
  public allSkinData() {
    let data_all = this.hokSkinData
    this.all_skin_data = [];
    this.all_skin_data_page = Object.keys(data_all).length;
    let obj = Object.keys(data_all).slice(
      (this.skin_page - 1) * this.skin_size,
      this.skin_page * this.skin_size
    ); //获取key
    // this.filter_page_data=obj
    let data = this.extractSubsetFromObject(data_all, obj);
    this.filter_page_data = data;

    for (let i in data) {
      let show = data[i].length > 1 ? true : false;
      data[i].forEach((v) => {
        if (v.level == 0) {
          this.all_skin_data.push({
            model: i,
            data: v,
            check: true,
            show: show,
            many: true,
          });
        }
      });
    }
  }
  public async expandCheck_all_add(data) {
    await this.dispatchGetHokSkinDataPage(store, {
      project: this.localProject,
      version: this.radio_versions === "全版本" ? "" : this.radio_versions,
      type: this.radio_test,
      action: this.radio_test == 4 ? "" : this.hero_skin,
      hero_skin: data.model,
      device: this.radio_device,
      start_date: this.start_date,
      end_date: this.end_date,
      order_by: this.order_by,
      reverse: this.reverse,
      page: this.all_skin_data.filter((v) => v.model == data.model).length,

      is_pass: this.is_pass ? "no_pass" : "pass",
    });
    if (this.addHokAll.length > 0) {
      let list = [];
      this.addHokAll.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      this.all_skin_data.forEach((v) => {
        if (v.model == data.model) {
          v.check = false;
        }
      });
      this.insertAfterLastOccurrenceAll(data.model, this.addHokAll);
      this.insertAfterLastOccurrenceAddAll(data.model, list);
      const modelMap = new Map();

      // 标记最后一个相同model为true，其他为false
      for (let i = this.all_skin_data.length - 1; i >= 0; i--) {
        const model = this.all_skin_data[i].model;

        if (!modelMap.has(model)) {
          this.all_skin_data[i].many = true; // 最后一个相同model的many设为true
          modelMap.set(model, true);
        } else {
          this.all_skin_data[i].many = false; // 之前出现过的设为false
        }
      }
      const modelMap1 = new Map();

      // 首先遍历所有的数据，将每个 model 出现的索引记录下来
      for (let i = 0; i < this.all_skin_data.length; i++) {
        const model = this.all_skin_data[i].model;

        // 如果 map 中没有这个 model，初始化为一个空数组
        if (!modelMap1.has(model)) {
          modelMap1.set(model, []);
        }

        // 将当前索引添加到对应的 model 的数组中
        modelMap1.get(model).push(i);
      }

      // 遍历 modelMap，并设置第一个出现的该 model 的 show 为 true，其余为 false
      modelMap1.forEach((indices) => {
        // 如果同一个 model 只出现一次，设置 show 为 false
        if (indices.length === 1) {
          this.all_skin_data[indices[0]].show = false;
        } else {
          // 如果同一个 model 出现多次，第一个设置为 true，其他设置为 false
          this.all_skin_data[indices[0]].show = true;
          for (let i = 1; i < indices.length; i++) {
            this.all_skin_data[indices[i]].show = false;
          }
        }
      });
    } else {
      ElMessage.error("暂无更多数据");
    }
  }
  public order_by = "";
  public reverse = "-";
  public heroSkinChange() {
    this.skin_check_id = this.hokIcon.skin_list[this.hero_check_id][0].skin_id;
    this.all_skin_data_api(true);
  }
  public formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零
    const day = String(date.getDate()).padStart(2, "0"); // 补零
    return `${year}-${month}-${day}`;
  }
  public timeChange(dates) {
    this.radio_time = 0;
    if (dates && dates.length === 2) {
      this.start_date = this.formatDate(dates[0]);
      this.end_date = this.formatDate(dates[1]);
    } else {
      this.start_date = "";
      this.end_date = "";
    }
    this.all_skin_data_api(true);
  }
  public hokOutData = {};
  
  get kingAction() {
    const device = (this.device_out_list || []).find(item => item.id == this.device_out)
    const model = device?.model

    if (model?.includes('J200') || model?.includes('A33')) {
      return [
        { label: "站定", value: "idle" },
      ]
    } else {
      return [
        { label: "进场", value: "come" },
        { label: "站定", value: "idle" },
      ]
    }
  }

  public target_index = "";
  public action = "idle";
  
  public async deviceInChange() {
    this.inside_trend_loading = true;
    await this.dispatchGetHokInSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      device_id: this.device_in,
      quality: this.device_list.filter((v) => v.id == this.device_in)[0]
        ?.quality,
    });
    this.drawInSide();
    this.inside_trend_loading = false;
  }
  public async deviceOutChange() {
    this.action = 'idle'
    this.target_index_out = 'avg_fps'

    this.out_trend_loading = true;
    await this.dispatchGetHokOutSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      action: this.action,
      device_id: this.device_out,
      quality: this.device_out_list.filter((v) => v.id == this.device_out)[0]
        ?.quality,
    });
    this.drawOut();
    this.out_trend_loading = false;
  }
  public device_out = "";
  public device_in = "";
  public actionChange() {
    this.hok_out_trend();
  }
  public skin_page = 1;
  public skin_size = 10;
  public target_types = [
    "avg_cpu",
    "avg_fps",
    "avg_pss",
    "avg_vss",
    "gpu_usage",
    "max_pss",
    "max_vss",
    "min_fps",
    "var_fps",
  ];
  
  public hokinsideChange() {
    this.drawInSide();
  }
  public hokoutChange() {
    this.drawOut();
  }
  public sort_change(column) {
    this.order_by = column.prop ? column.prop : "";
    this.reverse = column.order
      ? column?.order == "ascending"
        ? ""
        : "-"
      : "";
    this.all_skin_data_api(true);
  }
  public target_index_out = "avg_fps";
  public insertAfterLastOccurrence(model, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    this.hokinData[model].forEach((device, index) => {
      if (device.model === model) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      this.hokinData[model].splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      this.hokinData[model].push(...newDevice);
    }
  }
  public insertAfterLastOccurrenceAll(model, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    this.filter_page_data[model].forEach((device, index) => {
      if (device.model === model) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      this.filter_page_data[model].splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      this.filter_page_data[model].push(...newDevice);
    }
  }
  public insertAfterLastOccurrenceOut(model, action, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    this.hokOutData[model][action].forEach((device, index) => {
      if (device.model === model && device.action == action) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      this.hokOutData[model][action].splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      this.hokOutData[model][action].push(...newDevice);
    }
  }
  public insertAfterLastOccurrenceOutAdd(model, action, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    this.hok_out_table.forEach((device, index) => {
      if (device.model === model && device.action == action) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      this.hok_out_table.splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      this.hok_out_table.push(...newDevice);
    }
  }
  public insertAfterLastOccurrenceAdd(model, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    this.hok_inside_table.forEach((device, index) => {
      if (device.model === model) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      this.hok_inside_table.splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      this.hok_inside_table.push(...newDevice);
    }
  }
  public insertAfterLastOccurrenceAddAll(model, newDevice) {
    // Find the last occurrence of the given model
    let lastIndex = -1;
    this.all_skin_data.forEach((device, index) => {
      if (device.model === model) {
        lastIndex = index;
      }
    });

    // Insert the new device after the last occurrence
    if (lastIndex !== -1) {
      this.all_skin_data.splice(lastIndex + 1, 0, ...newDevice);
    } else {
      // If the model is not found, append the new device at the end
      this.all_skin_data.push(...newDevice);
    }
  }
  public async expandCheckAdd(data) {
    // console.log( this.hok_inside_table.filter(v=>v.model==data.model))

    await this.dispatchGetHokInAdd(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      device_name: data.model,
      page: this.hok_inside_table.filter((v) => v.model == data.model).length,
      quality: data.data.quality,
    });
    if (this.addHokIn.length > 0) {
      let list = [];
      this.addHokIn.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      this.insertAfterLastOccurrence(data.model, this.addHokIn);
      this.insertAfterLastOccurrenceAdd(data.model, list);
      let occurrenceCount = {};
      let lastOccurrence = {};
      this.hok_inside_table.forEach((device, index) => {
        let model = device.model;
        if (!occurrenceCount[model]) {
          occurrenceCount[model] = 0;
        }
        occurrenceCount[model]++;
        lastOccurrence[model] = index;
      });

      // Second pass to set the 'many' field
      this.hok_inside_table.forEach((device, index) => {
        let model = device.model;
        if (occurrenceCount[model] > 1) {
          device.many = index === lastOccurrence[model];
        } else {
          device.many = false;
        }
      });
    } else {
      ElMessage.error("暂无更多数据");
    }
  }
  public async expandCheckOutAdd(data) {
    // console.log( this.hok_inside_table.filter(v=>v.model==data.model))

    await this.dispatchGetHokOutAdd(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      device_name: data.model,
      page: this.hok_out_table.filter(
        (v) => v.model == data.model && v.action == data.action
      ).length,
      action: data.action,
    });
    if (this.addHokOut.length > 0) {
      let list = [];
      this.addHokOut.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
          action: data.action,
        });
      });
      this.insertAfterLastOccurrenceOut(
        data.model,
        data.action,
        this.addHokOut
      );
      this.insertAfterLastOccurrenceOutAdd(data.model, data.action, list);
      let occurrenceCount = {};
      let lastOccurrence = {};

      // First pass to count occurrences and find last occurrence index
      this.hok_out_table.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (!occurrenceCount[key]) {
          occurrenceCount[key] = 0;
        }
        occurrenceCount[key]++;
        lastOccurrence[key] = index;
      });

      // Second pass to set the 'many' field
      this.hok_out_table.forEach((device, index) => {
        let key = `${device.model}_${device.action}`;
        if (occurrenceCount[key] > 1) {
          device.many = index === lastOccurrence[key];
        } else {
          device.many = false;
        }
      });
    } else {
      ElMessage.error("暂无更多数据");
    }
  }
  public mergeCells2({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.all_skin_data.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.all_skin_data.findIndex((item) => item.model === row.model) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public expandCheck_all(data) {
    data.check = !data.check;

    if (!data.check) {
      let list = [];
      let addData = this.filter_page_data[data.model].filter(
        (v) => v.level != 0
      );

      addData.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      let index = this.all_skin_data.findIndex(
        (v) => v.model == data.model && v.data.time == data.time
      );
      if (index !== -1) {
        // 确保找到了索引
        this.all_skin_data.splice(index + 1, 0, ...list);
      }
    } else {
      this.all_skin_data = this.all_skin_data.filter(
        (item) => !(item.model === data.model && item.data.level === 1)
      );
    }
    const modelMap = new Map();

    // 标记最后一个相同model为true，其他为false
    for (let i = this.all_skin_data.length - 1; i >= 0; i--) {
      const model = this.all_skin_data[i].model;

      if (!modelMap.has(model)) {
        this.all_skin_data[i].many = true; // 最后一个相同model的many设为true
        modelMap.set(model, true);
      } else {
        this.all_skin_data[i].many = false; // 之前出现过的设为false
      }
    }
    data.many = false;
  }
  public expandCheck(data) {
    data.check = !data.check;

    if (!data.check) {
      let list = [];
      let addData = this.hokinData[data.model].filter((v) => v.level != 0);

      addData.forEach((v) => {
        list.push({
          model: data.model,
          data: v,
        });
      });
      let index = this.hok_inside_table.findIndex(
        (v) => v.model == data.model && v.data.time == data.time
      );
      if (index !== -1) {
        // 确保找到了索引
        this.hok_inside_table.splice(index + 1, 0, ...list);
      }
    } else {
      this.hok_inside_table = this.hok_inside_table.filter(
        (item) => !(item.model === data.model && item.data.level === 1)
      );
    }
    let occurrenceCount = {};
    let lastOccurrence = {};
    this.hok_inside_table.forEach((device, index) => {
      let model = device.model;
      if (!occurrenceCount[model]) {
        occurrenceCount[model] = 0;
      }
      occurrenceCount[model]++;
      lastOccurrence[model] = index;
    });

    // Second pass to set the 'many' field
    this.hok_inside_table.forEach((device, index) => {
      let model = device.model;
      if (occurrenceCount[model] > 1) {
        device.many = index === lastOccurrence[model];
      } else {
        device.many = false;
      }
    });
  }

  public expandCheckOut(data) {
    data.check = !data.check;
    if (!data.check) {
      let list = [];
      let addData = this.hokOutData[data.model][data.action].filter(
        (v) => v.level != 0
      );

      addData.forEach((v) => {
        list.push({
          model: data.model,
          action: data.action,
          data: v,
        });
      });
      let index = this.hok_out_table.findIndex(
        (v) =>
          v.model == data.model &&
          v.data.time == data.time &&
          v.action == data.action
      );
      if (index !== -1) {
        // 确保找到了索引
        this.hok_out_table.splice(index + 1, 0, ...list);
      }
    } else {
      this.hok_out_table = this.hok_out_table.filter(
        (item) =>
          !(
            item.model === data.model &&
            item.data.level === 1 &&
            item.action == data.action
          )
      );
    }
    let occurrenceCount = {};
    let lastOccurrence = {};

    // First pass to count occurrences and find last occurrence index
    this.hok_out_table.forEach((device, index) => {
      let key = `${device.model}_${device.action}`;
      if (!occurrenceCount[key]) {
        occurrenceCount[key] = 0;
      }
      occurrenceCount[key]++;
      lastOccurrence[key] = index;
    });

    // Second pass to set the 'many' field
    this.hok_out_table.forEach((device, index) => {
      let key = `${device.model}_${device.action}`;
      if (occurrenceCount[key] > 1) {
        device.many = index === lastOccurrence[key];
      } else {
        device.many = false;
      }
    });
  }
  public openBatchGenerateSkins() {
    // 使用 $router.resolve 方法获取新页面的 URL
    const routeData = this.$router.resolve({
      path: "/batch_generate_skins",
    });

    // 使用 window.open 在新页面打开 URL
    window.open(routeData.href, "_blank");
  }

  public extractBracketContents(input) {
    const regex = /(.+?)(（[^（）]*（?.*?）?）)/;
    const matches = input.match(regex);

    if (matches) {
      const textOutsideBrackets = matches[1];
      const textInsideBrackets = matches[2];
      return { textOutsideBrackets, textInsideBrackets };
    } else {
      console.log("未找到匹配的括号内容。");
      return null;
    }
  }
  public mergeCells1({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.hok_inside_table.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.hok_inside_table.findIndex(
            (item) => item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mergeCells({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.hok_out_table.filter(
        (item) => item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.hok_out_table.findIndex((item) => item.model === row.model) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = this.hok_out_table.filter(
        (item) => item.action === row.action && item.model === row.model
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.hok_out_table.findIndex(
            (item) => item.action === row.action && item.model === row.model
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public checkHok = true;
  public hero_id = "";
  public skin_icon = "";
  public skin_id = "";
  public skin_name = "";
  public hero_name = "";
  public hok_inside_table = [];
  public hok_out_table = [];
  public hokinData = {};
  public drawInSide() {
    let data = [];
    this.hok_in_trend_data?.device_names.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        data: this.hok_in_trend_data.series[index].map(
          (v) => v[this.target_index]
        ),

        symbol: "circle", //拐点设置为实心
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
              color: "#fff", //
            },
            color: "#4ED8DA", //
          },
        },
      });
    });
    let performance_line: any = document.getElementById("skin_inside");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      backgroundColor: "#393E44", // 设置背景色
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.hok_in_trend_data.x_axis,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: data,
    });
  }
  public drawOut() {
    let data = [];
    this.hok_out_trend_data?.device_names.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        data: this.hok_out_trend_data.series[index].map(
          (v) => v[this.target_index_out]
        ),

        symbol: "circle", //拐点设置为实心
        symbolSize: 8, // 调整数据点大小
        itemStyle: {
          normal: {
            lineStyle: {
              width: 4, // 设置线宽
            },

            label: {
              // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
              show: true,
              color: "#fff", //
            },
            color: "#4ED8DA", //
          },
        },
      });
    });
    let performance_line: any = document.getElementById("skin_out");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      backgroundColor: "#393E44", // 设置背景色
      tooltip: {
        trigger: "axis",
        confine: true,
        textStyle: {
          color: "#fff", // 文字颜色为白色
        },
        backgroundColor: "#2D3136", // 半透明黑色,
      },
      // title: {
      //   left: "center",

      //   text: "日稳定包函数耗时趋势图(百分比)",
      // },
      legend: {
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        textStyle: {
          color: "#fff", // 设置legend文字颜色
        },
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置yAxis文字颜色
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#606469",
          },
        },
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "15%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.hok_out_trend_data.x_axis,
        axisLabel: {
          textStyle: {
            color: "#fff", // 设置xAxis文字颜色
          },
        },
        axisLine: {
          lineStyle: {
            color: "#606469", // 修改 X 轴颜色
          },
        },
      },

      series: data,
    });
  }
  public hokInSide() {
    let data = this.hokinData
    this.hok_inside_table = [];
    for (let i in data) {
      let show = data[i].length > 1 ? true : false;
      data[i].forEach((v) => {
        if (v.level == 0) {
          this.hok_inside_table.push({
            model: i,
            data: v,
            check: true,
            show: show,
          });
        }
      });
    }
  }
  public skin_version_api() {
    this.dispatchGetHokSkinVersions(store, {
      project: this.localProject,
    });
  }
  
  public start_date: any = "";
  public end_date = "";
  public time_list = [
    { name: "全部", value: 4 },
    { name: "近半年", value: 5 },
    { name: "近一年", value: 6 },
  ];
  public year = [];
  public test_type = [
    { name: "局内", value: 4 },
    { name: "局外", value: 3 },
  ];
  public radio_time = 4;
  public test_type_chek = [
    {
      name: "入场",
      value: "come",
    },
    {
      name: "待机",
      value: "idle",
    },
  ];
  public is_pass = false;
  public async all_skin_data_api(type) {
    this.skin_page = type ? 1 : this.skin_page;
    this.all_skin_loading = true;
    await this.dispatchGetHokSkinData(store, {
      project: this.localProject,
      version: this.radio_versions === "全版本" ? "" : this.radio_versions,
      type: this.radio_test,
      action: this.radio_test == 4 ? "" : this.hero_skin,
      hero_skin:
        this.hero_check == "英雄"
          ? "hero"
          : this.hero_check == "全部"
          ? ""
          : this.skin_check_id,
      device: this.radio_device,
      start_date: this.start_date,
      end_date: this.end_date,
      order_by: this.order_by,
      reverse: this.reverse,
      page: this.skin_page,
      page_size: this.skin_size,
      is_pass: this.is_pass ? "no_pass" : "pass",
      level: ''
    });
    this.allSkinData();
    this.all_skin_loading = false;
  }
  public exportSkin() {
    let b = (this as any).$message({
      //Message 消息提示
      message: "导出中,请耐心等待....",
      showClose: true,
      duration: 0,
    });
    const response_data = this.dispatchGetHokSkinDataExport(store, {
      project: this.localProject,
      version: this.radio_versions === "全版本" ? "" : this.radio_versions,
      type: this.radio_test,
      action: this.radio_test == 4 ? "" : this.hero_skin,
      hero_skin:
        this.hero_check == "英雄"
          ? this.hokIcon.hero_list.filter(
              (v) => v.hero_id == this.hero_check_id
            )[0].hero_name
          : this.skin_check_id,
      device: this.radio_device,
      start_date: this.start_date,
      end_date: this.end_date,
      order_by: this.order_by,
      reverse: this.reverse,
      page: this.skin_page,
      page_size: this.skin_size,
      is_pass: this.is_pass ? "pass" : "no_pass",
    });
    response_data.then((value) => {
      var elink = document.createElement("a");
      elink.download = "性能总表" + ".xlsx";
      elink.style.display = "none";
      var blob = new Blob([value], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });

      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      b.close();
    });
  }
  public hero_skin = "";
  public hero_list = ["全部", "英雄", "英雄和皮肤"];
  public hero_check = "全部";
  public radio_test = 4;
  public radio_versions = "全版本";
  public get devices_versions() {
    const devices = this.skinDevices

    // 找到 SM-J200 的设备对象
    const targetDeviceIndex = devices.findIndex(
      (device) => device.model === "SM-J200"
    );
    if (targetDeviceIndex !== -1) {
      // 将该设备移到数组第一位
      const [targetDevice] = devices.splice(targetDeviceIndex, 1);
      devices.unshift(targetDevice);
    }

    return devices;
  }
  public radio_device = 0;
  public async skin_device_api() {
    await this.dispatchGetHokSkinDevices(store, {
      project: this.localProject,
      type: this.radio_test,
    });
    this.radio_device = this.devices_versions[0].id;
  }
  public num = 0;
  public async handleClickTab() {
    if (this.activeName == "second") {
      this.num++;
      if (this.num == 1) {
        await this.skin_version_api();
        await this.skin_device_api();
        this.all_skin_data_api(true);
      }
    }
  }
  public hokInOut() {
    let data = this.hokOutData;
    this.hok_out_table = [];
    for (let i in data) {
      for (let n in data[i]) {
        let show = data[i][n].length > 1 ? true : false;
        data[i][n].forEach((v) => {
          if (v.level == 0) {
            this.hok_out_table.push({
              model: i,
              action: n,
              data: v,
              check: true,
              show: show,
            });
          }
        });
      }
    }
  }
  public inside_loading = true;
  public out_loading = true;
  public inside_trend_loading = true;
  public out_trend_loading = true;
  public activeName = "first";
  public test_change() {
    this.skin_device_api();
    if (this.radio_test == 3) {
      this.hero_skin = "come";
    }
    this.all_skin_data_api(true);
  }
  public async confirm() {
    this.checkHok = true;
    this.inside_loading = true;
    this.out_loading = true;
    this.inside_trend_loading = true;
    this.out_trend_loading = true;
    this.hero_name = this.hokIcon.hero_list.filter(
      (v) => v.hero_id == this.hero_id
    )[0].hero_name;
    if (this.skin_id == "") {
      //   console.log(this.hokIcon.skin_list[this.hero_id],this.hokIcon.skin_list[this.hero_id].filter(v=>
      //    v.skin_name=='经典'
      //  ))
      this.skin_id = this.hokIcon.skin_list[this.hero_id].filter(
        (v) => v.skin_name == "经典"
      )[0].skin_id;
    }
    this.skin_icon = this.hokIcon.skin_list[this.hero_id].filter(
      (v) => v.skin_id == this.skin_id
    )[0].icon;
    this.skin_name = this.hokIcon.skin_list[this.hero_id].filter(
      (v) => v.skin_id == this.skin_id
    )[0].skin_name;
    this.hok_inside_api();
    this.hok_out_api();
    await this.deviceList_api();
    if (this.device_list?.length > 0) {
      this.device_in = this.device_list[0].id;
    } else {
      this.device_in = "";
    }
    if (this.device_out_list?.length > 0) {
      this.device_out = this.device_out_list[0].id;
    } else {
      this.device_out = "";
    }
    this.$router.push({
      query: {
        ...this.$route.query,
        hero_id: this.hero_id,
        skin_id: this.skin_id,
      },
    });
    this.hok_in_trend();
    this.hok_out_trend();
  }
  public hero_check_id = "";
  public skin_check_id = "";
  public getSkin_icon_name() {
    // this.skin_icon = this.hokIcon.skin_list[this.hero_id][0].icon;
    // this.skin_name = this.hokIcon.skin_list[this.hero_id][0].skin_name;
    this.skin_id = this.$route.query.skin_id
      ? this.$route.query.skin_id
      : this.hokIcon.skin_list[this.hero_id][0].skin_id;
    this.hero_name = this.hokIcon.hero_list.filter(
      (v) => v.hero_id == this.hero_id
    )[0].hero_name;
    this.skin_icon = this.hokIcon.skin_list[this.hero_id].filter(
      (v) => v.skin_id == this.skin_id
    )[0].icon;
    this.skin_name = this.hokIcon.skin_list[this.hero_id].filter(
      (v) => v.skin_id == this.skin_id
    )[0].skin_name;
  }
  public async hok_inside_api() {
    await this.dispatchGetHokIn(store, {
      project: this.localProject,
      skin_id: this.skin_id,
    });
    this.hokInSide();
    this.inside_loading = false;
  }
  public async hok_out_api() {
    await this.dispatchGetHokOut(store, {
      project: this.localProject,
      skin_id: this.skin_id,
    });
    this.hokInOut();
    this.out_loading = false;
  }
  public async deviceList_api() {
    await this.dispatchGetHokDeviceList(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      type: 4,
    });
    await this.dispatchGetHokDeviceOutList(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      type: 3,
    });
  }
  public async hok_in_trend() {
    await this.dispatchGetHokInSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      device_id: this.device_in,
      quality: this.device_list.filter((v) => v.id == this.device_in)[0]
        ?.quality,
    });
    this.drawInSide();
    this.inside_trend_loading = false;
  }
  public async hok_out_trend() {
    await this.dispatchGetHokOutSkinTrend(store, {
      project: this.localProject,
      skin_id: this.skin_id,
      action: this.action,
      device_id: this.device_out,
      quality: this.device_out_list.filter((v) => v.id == this.device_out)[0]
        ?.quality,
    });
    this.drawOut();
    this.out_trend_loading = false;
  }
  public all_skin_loading = false;
  public get name_img() {
    return readUserProfile(store).username;
  }
  public async mounted() {
    // if (this.name_img != 'febechen' && this.name_img != 'v_qiaolinyi' && this.name_img != 'alexjli' && this.name_img != 'jiejiewei' && this.name_img != 'v_baofeiyan') this.$router.push({name: '404'})

    await this.dispatchGetHokIcon(store, {
      project: this.localProject,
    });
    this.inside_loading = true;
    this.out_loading = true;
    this.inside_trend_loading = true;
    this.out_trend_loading = true;

    this.hero_id = this.$route.query.hero_id
      ? Number(this.$route.query.hero_id)
      : this.hokIcon.hero_list[0].hero_id;
    this.hero_check_id = this.hokIcon.hero_list[0].hero_id;

    this.skin_check_id = this.hokIcon.skin_list[this.hero_check_id][0].skin_id;
    // this.hero_name = this.hokIcon.hero_list[0].hero_name;
    this.target_index = 'avg_fps';
    //this.target_index_out = this.target_types[0];
    //this.action = this.kingAction[0].value;

    this.getSkin_icon_name();
    await this.deviceList_api();

    const defaultInOption = this.device_list.find(item => item.model.includes('J200')) || this.device_list[0]
    this.device_in = defaultInOption?.id;
    
    const defaultOutOption = this.device_out_list.find(item => item.model.includes('J200')) || this.device_out_list[0]
    this.device_out = defaultOutOption?.id;

    this.hok_inside_api();
    this.hok_out_api();
    this.hok_in_trend();
    this.hok_out_trend();
    this.$router.push({
      query: {
        ...this.$route.query,
        hero_id: this.hero_id,
        skin_id: this.skin_id,
      },
    });
    // await dispatchGetHokOut(store,{
    //         project:this.localProject,
    // skin_id:this.skin_id
    // })
    // this.hokInOut()
  }
}
